import * as Yup from "yup";
import { formatDate } from "../../../../../../utils/utils";
import DownloadIcon from '../../../../../../assets/icons/download.svg';
import IconButton from '@mui/material/IconButton';
import React from "react";
export const categoryOptions = [
  { value: "KYC Documents", id: 1 },
  { value: "Agreements & Contracts", id: 2 },
  { value: "Onboarding Documents", id: 3 },
  { value: "Payment/Finance Documents", id: 4 },
  { value: "Product-Related", id: 5 },
  { value: "Meeting & Communication", id: 6 },
  { value: "Compliance/Legal", id: 7 },
];

export const UPLOAD_DOCUMENT_INITIAL_VALUES={
    documentName: "",
    documentCategory:"",
    files:[]
}
export const DOCUMENT_DIALOG_VALIDATION_SCHEMA=Yup.object({
  documentName: Yup.string().required("Document Name is required"),
  documentCategory: Yup.string().required("Category is required"),
  files: Yup.array()
    .min(1, "Please upload at least one file")
    .max(5, "You can upload a maximum of 5 files"),
})
const handleDownload = (doc: any) => {
  const url = doc?.link;
  console.log("Download URL:", url);
  if (!url) return;

  const link = document.createElement("a");
  link.href = url;
  link.download = doc.document_name || "document";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export const documentColumns=[
   {
    key: "documentName",
    label: "Document Name",
    render: (document: any) => document.document_name || "-",
  },
   {
    key: "documentCategory",
    label: "Category",
    render: (document: any) => document.document_category || "-",
  },
  {
    key:"uploadedOn",
    label: "Uploaded On",
    render: (document: any)=>formatDate(document.created_at)||"-"
  },
  {
    key: "download",
    label: "Action",
   render: (doc: any) =>
  React.createElement(IconButton, {
    onClick: (e) => {
      e.stopPropagation();
      handleDownload(doc);
    },
    className: "icon-button",
    disabled: !doc?.link,
    children: React.createElement("img", {
      src: DownloadIcon,
      alt: "download",
      className: "img-icon",
      style: { width: "24px", height: "24px" },
    }),
  }),
  },
]
